import _defineProperty from "@babel/runtime/helpers/defineProperty";
// https://tc39.es/ecma262/#sec-execution-contexts
export class AnalysisContext {
  constructor() {
    _defineProperty(this, "VariableEnvironment", void 0);
    _defineProperty(this, "LexicalEnvironment", void 0);
  }
}

// https://tc39.es/ecma262/#sec-environment-records
export class AnalysisEnvironment {
  constructor(outer) {
    _defineProperty(this, "OuterEnv", void 0);
    _defineProperty(this, "bindingSet", new Set());
    this.OuterEnv = outer;
  }
  HasBinding(name) {
    return this.bindingSet.has(name);
  }
  CreateBinding(name) {
    this.bindingSet.add(name);
  }
}
//# sourceMappingURL=AnalysisContext.js.map